export default __webpack_public_path__ + "static/erica-baxter-08ea39ce2aaa71abac3d83faa0d7ae43.png";